import { render, staticRenderFns } from "./OrderLoadStatus.vue?vue&type=template&id=18a5e992&"
import script from "./OrderLoadStatus.vue?vue&type=script&lang=js&"
export * from "./OrderLoadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports